// src/hooks/useAlert.js
import React, { useState, createContext, useContext } from 'react';

const AlertContext = createContext();

export const useAlert = () => {
    return useContext(AlertContext);
};

export const AlertProvider = ({ children }) => {
    const [alert, setAlert] = useState(null);

    const showAlert = (msg, type = 'success') => {
        setAlert({ msg, type });
        setTimeout(() => setAlert(null), 5000);
    };

    // --- THE FIX ---
    // The value provided to the context is now an object.
    // This allows other components to get exactly what they need,
    // for example: const { alert } = useAlert() OR const { showAlert } = useAlert()
    const value = { alert, showAlert };

    return (
        <AlertContext.Provider value={value}>
            {children}
        </AlertContext.Provider>
    );
};
